<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: black;
}

.content {
  padding-bottom: 40px;
}
</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Varia Afhaal</p>
      </b-col>
    </b-row>



    <b-row class="content">
      <b-col md="4">
        <div class="description_text">
        <p class="tags">thematic gathering, everyday technology, Varia, food</p>
        <p>Varia Afhaal are thematic gatherings based around the common experiences, everyday technologies and home economics of food preparation. With Varia Afhaal we create a context in which we can collectively develop a deeper understanding of sometimes abstract socio-economic and political topics by learning with and from each other through discussions, sketching, research, cooking and eating.</p>
        <p>In the first session in this series, <a href="https://varia.zone/en/varia-afhaal-chip-shortage.html">Chip Shortage or Chips on Demand</a>, we explored old vs new technologies, scarcity, supply chains and planned obsolescence while experimenting with a variety of ingredients to make and enjoy chips. The discussions and collective cooking/eating sessions was partially streamed using Varia's own radio streaming infrastructure.</p>
        <p>Chip Shortage or Chips on Demand was accompanied by the ongoing Open Sauce events, where participants combine the contents of open bottles of sauce to make new, delicious, unoriginal condiments.</p>
        <p>In the second session, Stock Exchange, we brought up conversations on exchange value, extraction, commodities, economics, self-sufficiency and survival, while exploring the possibilities around making, sharing and storing stock.</p>  
        <p>Varia Afhaal is organised together with Yoana Buzova and Simon Browne.</p>
        <p>This project is supported by the <a href="https://www.stimuleringsfonds.nl/">Creative Industries Fund NL.</a></p>

      </div>
      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/afhaal/chip_0002.png"></b-img>
        <p></p>
        <b-img class="img-fluid" src="media/afhaal/chip_0007.png"></b-img>
      </b-col>
      <b-col md="4">
        <b-img class="img-fluid" src="media/afhaal/chip_0012.png"></b-img>
        <p></p>
        <b-img class="img-fluid" src="media/afhaal/andgate.jpg"></b-img>
        <b-img class="img-fluid" src="media/afhaal/stock.jpg"></b-img>


      </b-col>

    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'VariaAfhaal',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
